import {SharedFileSection} from "./shared-file-section";
import {SharedFileType} from "./shared-file-type";

export class SharedFile {

  id!: string;
  section!: SharedFileSection;
  type!: SharedFileType;
  fileName!: string;
  sharingUser!: string;
  sharedWithEmail!: string;
  validDays!: number;

}
